import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  FaUserTie,
  FaBriefcase,
  FaClock,
  FaRupeeSign,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "../CaseResult/Results.css";
import Resultp from "./Result-p";

const Results = () => {
  const { id } = useParams();

  // Dynamic case data
  const cases = [
    {
      id: 1,
      category: "Business Law",
      name: "Corporate Tax Compliance",
      highlightedTags: [
        "Tax Filing",
        "Compliance",
        "Audits",
        "Tax Strategies",
        "Business Law",
      ],
      image: "/cd.webp",
      description:
        "Expert solutions for business tax filing, compliance, and audits. Providing tailored tax strategies for businesses to ensure proper tax planning.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Tax Compliance",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "4 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "John Doe",
        },
        {
          icon: <FaRupeeSign />,
          title: "Result Amount",
          text: "₹8,00,000",
        },
      ],
      about:
        "This case involved advising a client on corporate tax compliance. Our focus was to ensure that the client followed all necessary tax regulations while maximizing available deductions and credits.",
      challenges:
        "The main challenge was ensuring compliance with complex tax laws while minimizing penalties and avoiding audits. Our team had to carefully review past filings and make adjustments where necessary. At last case will resolved successfully.",
      strategy:
        "We utilized in-depth tax planning strategies and collaborated with tax authorities to resolve past issues. The team worked closely with the client to ensure all future filings were compliant.",
      result:
        "The client successfully met compliance requirements and avoided penalties, with tax savings that exceeded ₹8,00,000. At last case will resolved successfully and the strategy also helped to streamline their tax filing process.",
      contact: {
        address: "123 Lane, New Delhi, India",
        phone: "+1 234 567 890",
        email: "client@example.com",
      },
    },
    {
      id: 2,
      category: "Taxation",
      name: "Tax Audits & Disputes Case",
      highlightedTags: [
        "Tax Audits",
        "Disputes",
        "Tax Authorities",
        "Compliance",
        "Penalties",
      ],
      image: "/cc.webp",
      description:
        "Professional representation in tax audits, handling disputes with tax authorities, ensuring compliance, and minimizing penalties.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Tax Audits",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "5 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Sarah Smith",
        },
        {
          icon: <FaRupeeSign />,
          title: "Result Amount",
          text: "₹12,00,000",
        },
      ],
      about:
        "This case was focused on defending a client against tax audits. Our team ensured that the client complied with the authorities and handled disputes efficiently to minimize penalties and resolve issues.",
      challenges:
        "The challenge was resolving tax discrepancies between the client and the tax authorities. Negotiating favorable terms while maintaining compliance required careful consideration of the client's financial records. At last case will resolved successfully.",
      strategy:
        "We took a proactive approach by gathering all necessary documentation, conducting an internal review, and negotiating with the tax authorities to reach an agreement that minimized penalties.",
      result:
        "The client successfully resolved the audit dispute and saved ₹12,00,000 in penalties and fines. This resolution also ensured that the client's future filings remained fully compliant. At last case will resolved successfully.",
      contact: {
        address: "456 Road, Noida, India",
        phone: "+1 567 890 123",
        email: "client2@example.com",
      },
    },
    {
      id: 3,
      category: "Financial Planning",
      name: "Wealth Management & Tax Planning",
      highlightedTags: [
        "Wealth Management",
        "Tax Saving",
        "Retirement Planning",
        "Financial Services",
        "Personal Finance",
      ],
      image: "/dc.webp",
      description:
        "Specialized in wealth management, tax-saving strategies, and retirement planning. Providing comprehensive financial services for individuals.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Wealth Management",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "1 Year",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Michael Lee",
        },
        {
          icon: <FaRupeeSign />,
          title: "Result Amount",
          text: "₹15,00,000",
        },
      ],
      about:
        "This case involved guiding an individual on comprehensive financial planning, focusing on wealth management, tax-saving strategies, and long-term retirement planning.",
      challenges:
        "The challenge was balancing the client's short-term financial needs with their long-term goals. We also worked with the client to minimize tax liabilities while preserving their wealth. At last case will resolved successfully.",
      strategy:
        "We developed a tailored financial plan that included tax-efficient investment strategies and a retirement savings plan. The strategy also focused on diversifying investments to maximize returns while minimizing risks.",
      result:
        "The client was able to save ₹15,00,000 in taxes while achieving significant wealth accumulation, securing their future with an optimized financial plan. At last case will resolved successfully.",
      contact: {
        address: "789 Street, Mumbai, India",
        phone: "+1 987 654 321",
        email: "client3@example.com",
      },
    },
    {
      id: 4,
      category: "Corporate Finance",
      name: "Mergers & Acquisitions Case",
      highlightedTags: [
        "Mergers",
        "Acquisitions",
        "Financial Transitions",
        "Corporate Finance",
        "Regulations",
      ],
      image: "/pi.webp",
      description:
        "Focused on providing expert advice and handling mergers and acquisitions, ensuring smooth financial transitions and compliance with regulations.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Mergers & Acquisitions",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "8 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Elizabeth Brown",
        },
        {
          icon: <FaRupeeSign />,
          title: "Result Amount",
          text: "₹50,00,000",
        },
      ],
      about:
        "This case involved advising a corporation on a merger, handling due diligence, compliance, and ensuring the transaction was seamless for both parties.",
      challenges:
        "The challenge was navigating the complexities of the merger, ensuring all legal and regulatory requirements were met, and managing stakeholder interests throughout the process. At last case will resolved successfully.",
      strategy:
        "We coordinated the due diligence process, negotiated terms between parties, and ensured compliance with all legal and regulatory frameworks to ensure a successful merger.",
      result:
        "The merger was completed successfully, generating ₹50,00,000 in value for both parties while ensuring full compliance with applicable regulations. At last case will resolved successfully.",
      contact: {
        address: "123 Corporate Park, Delhi, India",
        phone: "+1 123 456 789",
        email: "client4@example.com",
      },
    },
    {
      id: 5,
      category: "Personal Finance",
      name: "Personal Tax & Tax Filing Case",
      highlightedTags: [
        "Tax Filing",
        "Individual Taxes",
        "Compliance",
        "Tax Deductions",
        "Financial Services",
      ],
      image: "/dv.webp",
      description:
        "Providing tax filing services for individuals, ensuring compliance with tax laws, and maximizing deductions to minimize tax liabilities.",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Tax Filing",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "2 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "John Doe",
        },
        {
          icon: <FaRupeeSign />,
          title: "Result Amount",
          text: "₹2,50,000",
        },
      ],
      about:
        "This case involved assisting an individual with tax filing, ensuring that they maximized available deductions while remaining compliant with tax laws.",
      challenges:
        "The challenge was optimizing the individual's tax deductions while maintaining full compliance. We also had to ensure that all supporting documents were accurately prepared. At last case will resolved successfully.",
      strategy:
        "We analyzed the client's income and expenses, maximizing deductions for education, medical, and other eligible expenses. We also ensured all required documents were submitted promptly.",
      result:
        "The individual successfully filed their taxes and received ₹2,50,000 in tax savings, ensuring that their filings were fully compliant with tax regulations. At last case will resolved successfully.",
      contact: {
        address: "456 Street, Bangalore, India",
        phone: "+1 234 567 890",
        email: "client5@example.com",
      },
    },
    {
      id: 6,
      category: "Accounting Services",
      name: "Bookkeeping & Accounting Case",
      highlightedTags: [
        "Bookkeeping",
        "Accounting",
        "Financial Reporting",
        "Business Records",
        "Compliance",
      ],
      image: "/aa.webp",
      description:
        "Expert bookkeeping and accounting services for businesses, ensuring accurate records, compliance, and financial reporting. This case implemented accounting best practices",
      gridCards: [
        {
          icon: <FaBriefcase />,
          title: "Case Type",
          text: "Bookkeeping",
        },
        {
          icon: <FaClock />,
          title: "Time Taken",
          text: "3 Months",
        },
        {
          icon: <FaUserTie />,
          title: "Lawyer",
          text: "Elizabeth Brown",
        },
        {
          icon: <FaRupeeSign />,
          title: "Result Amount",
          text: "₹6,00,000",
        },
      ],
      about:
        "This case involved assisting a business with bookkeeping and accounting services, ensuring they maintained accurate financial records and complied with financial reporting standards and implemented accounting best practices",
      challenges:
        "The challenge was ensuring that the business’s accounting records were up-to-date, error-free, and complied with financial regulations while avoiding costly mistakes.  At last case will resolved successfully. ",
      strategy:
        "We conducted thorough bookkeeping audits, implemented accounting best practices, and ensured timely reporting to keep the business financially compliant.",
      result:
        "The business successfully met all reporting requirements, saving ₹6,00,000 by avoiding penalties and maintaining accurate financial records. At last case will resolved successfully with no penalities and accuracy in numbers.",
      contact: {
        address: "789 Avenue, Chennai, India",
        phone: "+1 987 654 321",
        email: "client6@example.com",
      },
    },
  ];

  const [activeCase, setActiveCase] = useState(
    cases.find((c) => c.id === parseInt(id)) || cases[0],
  );

  const handleCaseClick = (caseId) => {
    const selectedCase = cases.find((c) => c.id === caseId);
    setActiveCase(selectedCase);
  };

  return (
    <>
      <Resultp />

      <div className="results-container">
        {/* Case Details Section */}
        <div className="case-details">
          <div className="left">
            <img src={activeCase.image} alt={activeCase.name} />
          </div>
          <div className="right">
            <p className="category">{activeCase.category}</p>
            <h3 className="h3-n">{activeCase.name}</h3>
            <p className="p-d">{activeCase.description}</p>
            {/* Grid Cards Section */}
            <div className="grid-cards">
              {activeCase.gridCards.map((card, index) => (
                <div className="grid-card" key={index}>
                  <div className="icon">{card.icon}</div>
                  <div className="c-pc">
                    <p className="c-pc-h">{card.title}</p>
                    <p>{card.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* About and Challenges Section */}
        <div className="info-section">
          <div className="left">
            <h3 className="info-h3">About This Case</h3>
            <p className="info-p">{activeCase.about}</p>
            <h3 className="info-h3">Challenges</h3>
            <p className="info-p">{activeCase.challenges}</p>
          </div>
          <div className="right">
            <div className="right-h">
              <h1 className="info-h3">Highlighted Tags</h1>
              <ul className="highlighted-tags">
                {activeCase.highlightedTags.map((tag, index) => (
                  <li key={index} className="tag-item">
                    {tag}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Legal Strategy and Results Section */}
        <div className="info-section">
          <div className="left">
            <h3 className="info-h3">Legal Strategy</h3>
            <p className="info-p">{activeCase.strategy}</p>
            <h3 className="info-h3">Results</h3>
            <p className="info-p">{activeCase.result}</p>
          </div>
          <div className="right">
            <div className="right-c">
              <h3 className="info-h3">Contact</h3>
              <p className="info-p">
                <FaMapMarkerAlt className="info-ic" />
                {activeCase.contact.address}
              </p>
              <p className="info-p">
                <FaPhoneAlt className="info-ic" /> {activeCase.contact.phone}
              </p>
              <p className="info-p">
                <FaEnvelope className="info-ic" /> {activeCase.contact.email}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Results;
